import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectCurrentPage = (state: StoreSchema) =>
    state.users.paginatedUsers?.currentPage || 1
